export default {"src":"/_next/static/media/prize_model_agreement_icons.a5026d6e.svg","height":43,"width":197,"blurWidth":0,"blurHeight":0};